import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { useRef, useState } from 'react';
import { MobileFilterPanel } from './MobileFilterPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MobileFilterButton() {
  const buttonRef = useRef(null);
  const [panelOpen, setPanelOpen] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      buttonRef: buttonRef,
      onClick: () => setPanelOpen(true),
      size: "sm",
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.filter"
      })
    }), panelOpen && /*#__PURE__*/_jsx(MobileFilterPanel, {
      onClose: () => setPanelOpen(false)
    })]
  });
}